import keyMirror from 'react-utils/keyMirror';
import { createAction, createRequestTypes, createRequestActions } from './utils';
export const UserCanGdprDeleteSelfActionTypes = keyMirror({
  FETCH_CAN_GDPR_DELETE_SELF: null,
  LOAD_CAN_GDPR_DELETE_SELF: null
});
export const FetchCanGdprDeleteSelfActionTypes = createRequestTypes(UserCanGdprDeleteSelfActionTypes.FETCH_CAN_GDPR_DELETE_SELF);
export const FetchUserCanGdprDeleteSelf = createRequestActions(FetchCanGdprDeleteSelfActionTypes);
export const loadCanGdprDeleteSelf = () => createAction(UserCanGdprDeleteSelfActionTypes.LOAD_CAN_GDPR_DELETE_SELF);